import { Box, Typography, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Component to display customer name and verification status in a modal
const CustomerBankInfoMismatchModal = ({ 
  customerName, 
  bankVerifiedName, 
  open, 
  handleClose 
}) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '85%', md: 500, lg: 600 }, // Increased width for bigger modal
          bgcolor: 'background.paper',
          border: '2px solid',
          borderColor: 'error.main',
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 }, // Adjust padding based on screen size
          borderRadius: '12px', // Adjust border-radius for smoother look
        }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'grey.500',
            fontSize:'2rem'
          }}>
          <CloseIcon />
        </IconButton>
        <Typography
          id="modal-title"
          variant="h5"
          color={'red'}
          fontWeight={'bold'}
          gutterBottom
          marginBottom={'15px'}
          sx={{ fontSize: { xs: '2rem', sm: '2rem', md: '2rem' } }} // Adjust title size
        >
          Customer Name Verification Failed
        </Typography>
        <Typography id="modal-description" variant="body1" gutterBottom sx={{ fontSize: { xs: '1.8rem', sm: '1.8rem', md: '1.8rem' } }}>
          <strong>Customer name in VJ system:</strong> {customerName || 'Not Available'}
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ fontSize: { xs: '1.8rem', sm: '1.8rem', md: '1.8rem' } }}>
          <strong>Name verified by Bank :</strong> {bankVerifiedName || 'Not Available'}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '1.5rem', sm: '1.2rem', md: '1.5rem' },
            color: '#6B7280',
            marginTop: '20px'
          }}
        >
          <strong style={{
            color:"blue"
          }}>Important:</strong> Your name in our database doesn’t match with the bank information. Please contact your <strong>Sales Manager or CRM </strong> for further help.
        </Typography>
      </Box>
    </Modal>
  );
};

export default CustomerBankInfoMismatchModal;